import React, { useState, useEffect } from "react";
import MLActionBar from "./MSActionBar/ActionBar";
import DynamicTable from "../../../components/Table/MTable";
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer/Footer"; // Import your Footer component
import axios from "axios";
import { useSelector } from "react-redux";

const MStage = () => {
  const [stages, setStages] = useState([]);
  const [filteredStages, setFilteredStages] = useState([]);
  const { role } = useSelector((state) => state.auth);
  const [selectedRow, setSelectedRow] = useState(null); // To track selected row
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const apiEndpoint = `${API_BASE_URL}/mstage/mstages`;

  const columns = [
    { key: "StageID", label: "Stage ID" },
    { key: "StageName", label: "Stage Name" },
  ];

  // Fetch stages
  const fetchStages = async () => {
    try {
      const response = await axios.get(apiEndpoint);
      setStages(response.data);
      setFilteredStages(response.data);
    } catch (error) {
      console.error("Error fetching stages:", error);
    }
  };

  // Handle search
  const handleSearch = (query) => {
    if (!query) {
      setFilteredStages(stages);
    } else {
      setFilteredStages(
        stages.filter((loc) =>
          loc.StageName.toLowerCase().includes(query.toLowerCase())
        )
      );
    }
  };

  useEffect(() => {
    fetchStages();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <Header exportEndpoint={apiEndpoint} />

      {/* Main Content */}
      <div className="flex-grow p-4">
        <MLActionBar
          title="Stages"
          rowKey="StageID"
          deleteMessage="Are you sure you want to remove this stage permanently?"
          fields={[
            { name: "StageName", label: "Name", required: true },
          ]}
          apiEndpoint={apiEndpoint}
          data={filteredStages}
          selectedRow={selectedRow} // Pass selected row to ActionBar
          onRowSelect={setSelectedRow} // Set selected row when clicked
          onRefresh={fetchStages}
          onSearch={handleSearch}
          userRole={role} // Pass the user role
        />
        
        {/* Table Heading */}
        <div className="mt-6 mb-2 text-center">
          <h3 className="text-xl font-semibold">Stage Table</h3>
        </div>

        {/* Dynamic Table */}
        <div className="mt-4">
          <DynamicTable
            columns={columns}
            data={filteredStages}
            selectedRow={selectedRow}
            onRowSelect={setSelectedRow}
            rowKey="StageID"
            highlightColor="bg-green-100"
            noDataMessage="No units found."
          />
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default MStage;
